module.exports = __webpack_public_path__ + "static/media/wicket-systri-warrick.fc29906d.jpg";